// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../../../config/screen';

export const SensorsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin: 1rem 0;
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
  margin-bottom: 1rem;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    margin-right: 0.5rem;
  };
`;

export const LastSeparator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
 margin-bottom: 1rem;
`;

export const EnableItemsContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    margin-right: 0.5rem;
  };
`;

export const LastEnableItemsContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;

  @media (max-width: ${BREAKPOINTS.xl - 1}px) {
    padding-bottom: 2rem;
  };
`;
